import React, { useMemo } from 'react';
import { PreviewTabIndex } from '.';

export function PreviewTypeDetail({ index }: { index: PreviewTabIndex }) {
  const label = useMemo(() => {
    switch (index) {
      case PreviewTabIndex.Record:
        return 'This is your recorded video message';
      case PreviewTabIndex.Email:
        return 'This is what you are sending to your recipient’s email inbox';
      case PreviewTabIndex.LandingPage:
        return 'This is the landing page your recipients will view from email';
    }
  }, [index]);

  return <span className='text-base py-2.5'>{label}</span>;
}
